import { Pagination } from "@material-ui/lab";
import useCustomState from "../../hooks/State";
import { Button, TextField } from "@material-ui/core";

const CustomPagination = ({
  page,
  totalPages,
  pageSize,
  totalData,
  changePageFunc,
}) => {
  const dynamicPage = useCustomState(page);
  return (
    <>
      <Pagination
        shape="rounded"
        size="large"
        variant="outlined"
        count={totalPages}
        page={page}
        onChange={(event, value) => changePageFunc(value)}
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>صفحه : </span>{" "}
        <TextField
          aria-readonly={true}
          value={dynamicPage.value}
          variant="standard"
          style={{
            maxWidth: "80px",
            marginLeft: "10px",
            marginRight: "10px",
          }}
          label=""
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          onChange={(e) => dynamicPage.handleChange(Number(e.target.value))}
          size="small"
        ></TextField>{" "}
        <Button
          disabled={
            !(
              Number(dynamicPage.value) &&
              Number(dynamicPage.value) <= totalPages &&
              Number(dynamicPage.value) > 1
            )
          }
          onClick={() => {
            if (
              Number(dynamicPage.value) &&
              Number(dynamicPage.value) <= totalPages &&
              Number(dynamicPage.value) > 1
            ) {
              changePageFunc(Number(dynamicPage.value));
            }
          }}
          style={{ color: "#fff" }}
          variant="contained"
          color="primary"
        >
          مشاهده
        </Button>{" "}
      </div>
      <div>
        صفحه {page} ، داده {(page - 1) * pageSize + 1} تا{" "}
        {page * pageSize > totalData ? totalData : page * pageSize} از{" "}
        {totalData} رکورد
      </div>
    </>
  );
};
export default CustomPagination;
